import router from "src/routes/routes";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);

export const reportsService = {
  getMonthlyBillingReport: async (params) => {
    return api.getCall('/api/reports/monthly-billing', params);
  },

  downloadMonthlyBillingReport: async (params) => {
    return api.getBlobCall('/api/reports/monthly-billing/csv', params);
  },

  getMonthlyBillingReportSimple: async (params) => {
    return api.getCall('/api/reports/monthly-billing-simple', params);
  },

  downloadMonthlyBillingReportSimple: async (params) => {
    return api.getBlobCall('/api/reports/monthly-billing-simple/csv', params);
  },

  getAllCodes: async () => {
    return api.getCall('/api/reports/all-codes');
  },

  getTimesheetBillingReport: async (params) => {
    return api.getCall('/api/reports/timesheet-billing', params);
  },

  downloadTimesheetBillingReport: async (params) => {
    return api.getBlobCall('/api/reports/timesheet-billing/csv', params);
  },

  getActiveAuthsNoShiftsReport: async (params) => {
    return api.getCall('/api/reports/active-auths-no-shifts', params);
  },

  downloadActiveAuthsNoShiftsReport: async (params) => {
    return api.getBlobCall('/api/reports/active-auths-no-shifts/csv', params);
  },

  getAuthsWithApprovedShiftsReport: async (params) => {
    return api.getCall('/api/reports/auths-with-approved-shifts', params);
  },

  downloadAuthsWithApprovedShiftsReport: async (params) => {
    return api.getBlobCall('/api/reports/auths-with-approved-shifts/csv', params);
  },

  getDspdShiftNotesReport: async (params) => {
    return api.getCall('/api/reports/dspd-shift-notes', params);
  },

  downloadDspdShiftNotesReport: async (params) => {
    return api.getBlobCall('/api/reports/dspd-shift-notes/csv', params);
  },

  getDspdConsolidatedBillingReport: async (params) => {
    return api.getCall('/api/reports/dspd-consolidated-billing', params);
  },

  downloadDspdConsolidatedBillingReport: async (params) => {
    return api.getBlobCall('/api/reports/dspd-consolidated-billing/csv', params);
  },

  getPbaBillingReport: async (params) => {
    return api.getCall('/api/reports/pba-billing', params);
  },

  downloadPbaBillingReport: async (params) => {
    return api.getBlobCall('/api/reports/pba-billing/csv', params);
  },

  getHoursUnitsConsolidatedReport: async (params) => {
    return api.getCall('/api/reports/hours-units-consolidated', params);
  },

  downloadHoursUnitsConsolidatedReport: async (params) => {
    return api.getBlobCall('/api/reports/hours-units-consolidated/csv', params);
  },

  getVrAuthConsolidationReport: async (params) => {
    return api.getCall('/api/reports/vr-auth-consolidation', params);
  },

  downloadVrAuthConsolidationReport: async (params) => {
    return api.getBlobCall('/api/reports/vr-auth-consolidation/csv', params);
  },

  getMonthlyUnitsReport: async (params) => {
    return api.getCall('/api/reports/monthly-units', params);
  },

  downloadMonthlyUnitsCSV: async (params) => {
    return api.getBlobCall('/api/reports/monthly-units/csv', params);
  },

  getAttendanceReport: async (params) => {
    return api.getCall('/api/reports/attendance', params);
  },

  getAllDspdReport: async (params) => {
    return api.getCall('/api/reports/all-dspd', params);
  },

  downloadAllDspdReport: async (params) => {
    return api.getBlobCall('/api/reports/all-dspd/csv', params);
  },

  getProjectionVsActualReport: async (params) => {
    return api.getCall('/api/reports/projection-vs-actual', params);
  },

  downloadProjectionVsActualReport: async (params) => {
    return api.getBlobCall('/api/reports/projection-vs-actual/csv', params);
  },

  getEVVReport: async (params) => {
    return api.getCall('/api/reports/evv', params);
  },

  downloadEVVReport: async (params) => {
    return api.getBlobCall('/api/reports/evv/csv', params);
  },

  getMileageReport: async (params) => {
    return api.getCall('/api/reports/mileage', params);
  },

  downloadMileageReport: async (params) => {
    return api.getBlobCall('/api/reports/mileage/csv', params);
  },

  getClientComplianceReport: async (params) => {
    return api.getCall('/api/reports/client-compliance', params);
  },

  downloadClientComplianceReport: async (params) => {
    return api.getBlobCall('/api/reports/client-compliance/csv', params);
  },

  getQuarterlySubmissionReport: async (params) => {
    return api.getCall('/api/reports/quarterly-submission', params);
  },

  downloadQuarterlySubmissionReport: async (params) => {
    return api.getBlobCall('/api/reports/quarterly-submission/csv', params);
  },
};
